module.exports = __webpack_public_path__ + "static/media/hab6-2.3d34fcc8.jpg";